



































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Notification } from '@/common/Notifications';

import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Filters from '@/components/Notifications/Filters.vue';
import Checkbox from '@/components/Form/Checkbox.vue';

import NotificationModal from '@/components/Modal/Notification.vue';
import jQuery from 'jquery';

@Component({
	name: 'Notifications',
	components: {
		Welcome,
		Alert,
		Filters,
		Checkbox,
		NotificationModal,
	},
})
export default class Notifications extends Vue {
	@Getter('notifications', { namespace: 'Notifications' })
	private notifications: Notification[];

	@Action('postNotifications', { namespace: 'Notifications' }) private postNotifications: any;

	private perPage: number = 15;
	private paginate: string[] = ['notifications'];
	private selectedNotifications: string[] = [];
	private selectedNotification: Partial<Notification> = {};
	private searchText: string = '';

	private async markUnread() {
		try {
			await this.postNotifications({
				cmd: 'mark_unread',
				notifications: this.selectedNotifications,
			});
			this.selectedNotifications = [];
		} catch (e) {
			console.log(e);
		}
	}

	private async markDeleted() {
		try {
			await this.postNotifications({
				cmd: 'delete',
				notifications: this.selectedNotifications,
			});
			this.selectedNotifications = [];
		} catch (e) {
			console.log(e);
		}
	}

	private async openNotification(id) {
		this.selectedNotification = this.notifications.find(n => n.id === id);
		jQuery('#Notification').modal({ show: true });

		try {
			await this.postNotifications({
				cmd: 'mark_read',
				notifications: [id],
			});
		} catch (e) {
			console.log(e);
		}
	}
}
